export const tutorialListOrder = ['planned_documents', 'participation_budget', 'geoproducts'];
